import styled from 'styled-components';
import Switch from "react-switch";

import { fonts, colors } from 'stylesheets';

export const RatingContainer = styled.div`
  text-align: center;
  p, span {
    font-family: ${fonts.primary};
  }
`;

export const Comment = styled.div`
  margin-top: 50px;
`;

export const CommentLabelPrimary = styled.span`
  display: flex;
  font-family: ${fonts.primary};
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  color: ${colors.greyDark};
`;

export const CommentLabelSecondary = styled.span`
  font-family: ${fonts.primary};
  font-style: normal;
  font-size: 13px;
  color: ${colors.greyDark};
`;

export const CommentBox = styled.textarea`
  border: 1px solid ${({ hasValue }) => (hasValue ? `${colors.greyDark}` : `${colors.greyLight}`)};
  border-radius: 2px;
  resize: none;
  width: 100%;
  margin: 5px 0;
  height: 150px;
  padding: 10px;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 5px 0px 80px 0px;
`

export const FooterText = styled.div`
  margin-right: 10px;
  margin-top: auto;
  font-family: ${fonts.primary};
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
`

export const FooterSwitch = styled(Switch)`
  margin-right: 10px;
`
